import { render, staticRenderFns } from "./WcFormsButtons.vue?vue&type=template&id=360b3552&lang=pug&"
import script from "./WcFormsButtons.vue?vue&type=script&lang=js&"
export * from "./WcFormsButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports